module.exports = __webpack_public_path__ + "img/5.c5edb58c.png";